import { useMemo } from 'react'
import { LoanReportData } from '../typesExtendedReport'
import { useMappedExtendedData } from '../useMappedExtendedData'
import { safeNum } from '../utils/extendedUtils'

export const useLoanMappedData = (
    data: LoanReportData | null | undefined,
    palette: string[]
) => {
    const base = useMappedExtendedData(data, palette)

    return useMemo(() => {
        if (!data || !base) return null

        const yearDisbTotal =
            safeNum(data.projectionsDisbursementsYearAmount) +
            safeNum(data.projectionsWithoutDisbursementsYearAmount)

        return {
            ...base,
            yearDisbTotal,
            approved: data.approvedprojects,
            fields: {
                projectTotalCount: safeNum(data.projectTotalCount),
                operationTotalCount: safeNum(data.operationTotalCount),
                averageAge: safeNum(data.averageAge),
                guarantees: safeNum(data.guarantees),
                investment: safeNum(data.investment),
                pbp: safeNum(data.pbp),
                idbApprovedAmountOriginal: safeNum(data.idbApprovedAmount_Original),
                idbApprovedAmountCurrent: safeNum(data.idbApprovedAmount_Current),
                guaranteesAmount: safeNum(data.guaranteesAmount),
                investmentAmount: safeNum(data.investmentAmount ?? (data as any).investmentAmout),
                pbpAmount: safeNum(data.pbpAmount),
                disbursementPercent: safeNum(data.disbursementPercent),
                disbursementAmount: safeNum(data.disbursementAmount),
                withoutDisbursingAmount: safeNum(data.withoutDisbursingAmount),
            },
        }
    }, [data, base])
}
